export function currencyFormatter(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "MVR",
  }).format(value);
}
